import { log } from '@hotjar/insights-common/lib/log';

/**
 * Google Adwords related tracking.
 */
let initialSetupComplete = false;

const callbacksAfterSetup: Array<() => void> = [];
const conversionConstants = {
  id: 966406048,
  signUpLabel: 'RiVnCKvLzl4QoN_ozAM',
  newCustomerLabel: '1avNCInGrHQQoN_ozAM',
};

window.google_trackConversion =
  // eslint-disable-next-line @typescript-eslint/no-empty-function, camelcase
  window.google_trackConversion || function google_trackConversion() {};

// Wait for Adwords to load, then run any method calls that's been triggered in the meantime.
const intervalId = setInterval(() => {
  if (window.google_trackConversion) {
    clearInterval(intervalId);
    initialSetupComplete = true;
    callbacksAfterSetup.forEach((callback) => callback());
  }
}, 500);

/**
 * If Adwords is loaded it simply executes the method call. If not, it will add it to the callback queue.
 * @param callback Method call to either execute or add to queue.
 */
function callOrQueue(callback: () => void) {
  if (initialSetupComplete) {
    callback();
  } else {
    callbacksAfterSetup.push(callback);
  }
}

/**
 * Track that a user signed up.
 */
export const trackSignup = (): void => {
  log.debug('Adwords: Tracking sign-up');
  callOrQueue(() => {
    if (window.google_trackConversion) {
      window.google_trackConversion({
        google_conversion_id: conversionConstants.id,
        google_conversion_label: conversionConstants.signUpLabel,
      });
    }
  });
};

/**
 * Track that a user has become a customer (he has paid us money for the first time).
 *
 * @param totalCost The total cost which the user spent on the first purchase.
 */
export const newCustomer = (totalCost: number): void => {
  log.debug('Adwords: Tracking new customer');
  callOrQueue(() => {
    if (window.google_trackConversion) {
      window.google_trackConversion({
        google_conversion_id: conversionConstants.id,
        google_conversion_label: conversionConstants.newCustomerLabel,
        google_conversion_value: totalCost,
      });
    }
  });
};
